module.exports = __webpack_public_path__ + "static/media/dayLimitPower2.596970bb.svg";